import React from "react";
import { Snackbar, Alert, Slide, Typography, Box, IconButton } from "@mui/material";
import { TickCircle, CloseCircle, InfoCircle } from "iconsax-react";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";

const TransitionUp = (props) => {
    return <Slide {...props} direction="up" />;
};

const Snackbar1 = ({ open, close_snack_bar, message }) => {
    const snackbarState = useSelector((state) => state.snackbar);
    const status = snackbarState?.status;

    const getSeverity = (status, msg = "") => {
        const lowerMsg = msg.toLowerCase();

        if (status === 200 || status === 201 || status === "success") return "success";
        if (status >= 400 || status === "error") return "error";

        if (lowerMsg.includes("success") || lowerMsg.includes("uploaded") || lowerMsg.includes("updated") || lowerMsg.includes("saved") || lowerMsg.includes("sent")) return "success";
        if (lowerMsg.includes("error") || lowerMsg.includes("failed") || lowerMsg.includes("invalid") || lowerMsg.includes("check") || lowerMsg.includes("wrong")) return "error";

        return "info";
    };

    const severity = getSeverity(status, message);

    const alertStyles = {
        success: {
            bgcolor: "#E6F7EF",
            color: "#008544",
            iconColor: "#00C853",
            border: "1px solid #B7EBCE"
        },
        error: {
            bgcolor: "#FDEDED",
            color: "#5F2120",
            iconColor: "#D32F2F",
            border: "1px solid #F5C6CB"
        },
        info: {
            bgcolor: "#E3F2FD",
            color: "#0D47A1",
            iconColor: "#2196F3",
            border: "1px solid #BBDEFB"
        }
    };

    const currentStyle = alertStyles[severity] || alertStyles.info;

    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={close_snack_bar}
            TransitionComponent={TransitionUp}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            sx={{ bottom: { xs: 24, sm: 40 } }}
        >
            <Alert
                onClose={close_snack_bar}
                severity={severity}
                icon={false}
                sx={{
                    width: "100%",
                    maxWidth: { xs: "90vw", sm: "500px" }, // Prevent too wide
                    minWidth: { xs: "300px", sm: "350px" },
                    bgcolor: currentStyle.bgcolor,
                    color: currentStyle.color,
                    border: currentStyle.border,
                    borderRadius: 3,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    py: 0.5,
                    px: 2,
                    alignItems: "center",
                    overflow: "hidden", // Disable scrolling
                    "& .MuiAlert-message": {
                        padding: 0,
                        width: '100%',
                        overflow: "hidden" // Ensure internal message doesn't scroll
                    },
                    "& .MuiAlert-action": {
                        paddingLeft: 1,
                        alignItems: "center",
                        paddingTop: 0
                    }
                }}
                action={
                    <IconButton onClick={close_snack_bar} size="small" sx={{ p: 0.5, color: currentStyle.color, opacity: 0.7 }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            >
                <Box display="flex" alignItems="center" gap={1.5}>
                    {severity === 'success' && <TickCircle size="24" color={currentStyle.iconColor} variant="Bold" />}
                    {severity === 'error' && <CloseCircle size="24" color={currentStyle.iconColor} variant="Bold" />}
                    {severity === 'info' && <InfoCircle size="24" color={currentStyle.iconColor} variant="Bold" />}

                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="subtitle2" fontWeight={700} sx={{ lineHeight: 1.1, fontSize: '0.9rem' }}>
                            {severity === 'success' ? 'Success' : severity === 'error' ? 'Error' : 'Note'}
                        </Typography>
                        <Typography
                            variant="body2"
                            fontWeight={500}
                            sx={{
                                opacity: 0.9,
                                lineHeight: 1.1,
                                fontSize: '0.85rem',
                                wordBreak: "break-word",
                                whiteSpace: "pre-wrap"
                            }}
                        >
                            {message}
                        </Typography>
                    </Box>
                </Box>
            </Alert>
        </Snackbar>
    );
};

export default Snackbar1;
